export default "__VITE_ASSET__8duec4xt__"